//const reg = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
const reg = /^\b[\w]{0,64}[-\w.]{0,64}[\w]@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;

const emailValidator = email => reg.test(email);

export default emailValidator;
